import { noop } from "../function/noop.mjs";
import { isEqualWith } from "./isEqualWith.mjs";
//#region src/predicate/isEqual.ts
/**
* Checks if two values are equal, including support for `Date`, `RegExp`, and deep object comparison.
*
* @param {unknown} a - The first value to compare.
* @param {unknown} b - The second value to compare.
* @returns {boolean} `true` if the values are equal, otherwise `false`.
*
* @example
* isEqual(1, 1); // true
* isEqual({ a: 1 }, { a: 1 }); // true
* isEqual(/abc/g, /abc/g); // true
* isEqual(new Date('2020-01-01'), new Date('2020-01-01')); // true
* isEqual([1, 2, 3], [1, 2, 3]); // true
*/
function isEqual(a, b) {
	return isEqualWith(a, b, noop);
}
//#endregion
export { isEqual };
